import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { ArrowIcon } from '../icons';

interface ExpandCashFlowCollectionProps {
  isEveryCashFlowCollectionExpanded: () => boolean;
  onExpand: () => void;
}

export const ExpandCashFlowCollection: React.FC<ExpandCashFlowCollectionProps> = ({
  isEveryCashFlowCollectionExpanded,
  onExpand,
}) => (
  <S.Container onClick={onExpand}>
    <S.IconContainer>
      <S.ArrowIcon direction={isEveryCashFlowCollectionExpanded() ? 'down' : 'right'} />
    </S.IconContainer>
    <S.Text>
      {isEveryCashFlowCollectionExpanded() ? (
        <FormattedMessage
          id="widgets.regular_cash_flows_analysis.collapse_all"
          defaultMessage="Collapse all"
          description="Label of button to fold every collection"
        />
      ) : (
        <FormattedMessage
          id="widgets.regular_cash_flows_analysis.expand_all"
          defaultMessage="Expand all"
          description="Label of button to expand every collection"
        />
      )}
    </S.Text>
  </S.Container>
);

const S = {
  Container: styled.div`
    align-items: center;
    display: inline-flex;

    &:hover {
      cursor: pointer;
    }
  `,
  IconContainer: styled.span`
    align-items: center;
    background: #ecf1f4;
    border-radius: 4px;
    display: flex;
    height: 20px;
    justify-content: center;
    margin-right: 7px;
    width: 20px;
  `,
  ArrowIcon: styled(ArrowIcon)`
    height: 10px;
  `,
  Text: styled.span`
    color: ${(props) => props.theme.algoanBlue};
    font-size: 9px;
    line-height: 11px;
  `,
};
